import { Table, Text } from '@mantine/core'
import { Camera } from '@/types/camera'
import { DeploymentStatus } from '@/types/deployment'
import { DeploymentGroup, DeploymentGroupMember } from '@/types/deploymentGroup'
import { CameraCell } from '../DeploymentList/CameraCell'
import { DeploymentStatusIndicator } from '../DeploymentList/DeploymentStatusIndicator/DeploymentStatusIndicator'
import { DeploymentGroupRowSlots } from './deploymentTreeTypes'

type GroupMemberRowProps = Pick<
  DeploymentGroupRowSlots,
  'renderMemberActions' | 'onOpenGroup'
> & {
  member: DeploymentGroupMember
  group: DeploymentGroup
  camera: Camera | null
  deviceActive?: boolean
  highlighted?: boolean
}

export const GroupMemberRow = ({
  member,
  group,
  camera,
  deviceActive,
  highlighted = false,
  renderMemberActions,
  onOpenGroup
}: GroupMemberRowProps) => {
  return (
    <Table.Tr
      data-highlighted={highlighted || undefined}
      bg={highlighted ? 'blue.0' : undefined}
      style={{ cursor: onOpenGroup ? 'pointer' : undefined }}
      onClick={() => onOpenGroup?.(group, member)}
    >
      <Table.Td>
        <CameraCell
          camera={camera}
          deviceActive={deviceActive ?? false}
          fallbackName={member.stream_id}
        />
      </Table.Td>

      <Table.Td w={240}>
        <DeploymentStatusIndicator
          status={member.status}
          statusUpdatedAt={member.status_updated_at}
          deviceActive={deviceActive}
        />

        {member.error_body && (
          <Text
            size="xs"
            mt={4}
            c={member.status === DeploymentStatus.Failed ? 'red' : 'orange'}
          >
            {member.error_body}
          </Text>
        )}
      </Table.Td>

      <Table.Td w={160} onClick={(e) => e.stopPropagation()}>
        {renderMemberActions?.(member, group)}
      </Table.Td>
    </Table.Tr>
  )
}
